(function ($, app) {
	'use strict';

	$(window).on('pageNavigation', init);
	function init() {
		$.validator.addMethod("oneormorechecked", function (value, element) {
			return $('input[name="' + element.name + '"]:checked').length > 0;
		}, "Selecteer tenminste 1");
	}
})(jQuery, window.app);